export const GET_FUNC_FICHA = 'GET_FUNC_FICHA';
export const LOADING_FUNC_FICHA = 'LOADING_FUNC_FICHA';
export const GET_FUNC_FICHA_EMPLEADO = 'GET_FUNC_FICHA_EMPLEADO';
export const LOADING_FUNC_FICHA_EMPLEADO = 'LOADING_FUNC_FICHA_EMPLEADO';